module.exports = __webpack_public_path__ + "img/banner_title_mobile_tc.18dbf223.gif";